import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, CreditCard } from "lucide-react";
import { api } from "@/lib/api";
import SubscribePlanModal from "./SubscribePlanModal";

export default function MyAdminEventDetail() {
  const { eventId } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [showSubscribe, setShowSubscribe] = useState(false);
  useEffect(() => {
    api.get(`/myadmin/events/${eventId}`)
      .then(r => setD(r.data))
      .catch(e => setErr(e?.response?.data?.detail || "Événement introuvable."));
  }, [eventId]);
  if (err) return <p data-testid="myadmin-event-detail-error" className="text-red-300 text-sm">{err}</p>;
  if (!d) return <p className="text-white/55 italic">Chargement…</p>;
  const e = d.event;
  const hasActivePlan = d.subscription?.status === "active";
  return (
    <div data-testid="myadmin-event-detail">
      <Link to="/admin/events" className="text-xs uppercase tracking-widest text-white/50 hover:text-[#DCB457] inline-flex items-center gap-1.5 mb-4"><ArrowLeft size={12} /> Retour</Link>
      <header className="mb-8">
        <p className="eyebrow">Événement · {e.type}</p>
        <h1 className="font-serif-luxe text-4xl mt-3">{e.name}</h1>
        <p className="text-white/60 text-sm mt-2">{e.date || "sans date"} {e.time && `· ${e.time}`} · {e.lieu || ""} {e.ville && `· ${e.ville}`}</p>
        <span className="mt-3 inline-block text-[10px] uppercase tracking-widest border border-[#DCB457]/40 px-2 py-1 text-[#DCB457]">{e.status}</span>
      </header>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card-luxe p-6" data-testid="section-members">
          <p className="eyebrow">Membres ({d.members.length})</p>
          <ul className="mt-4 divide-y divide-[#DCB457]/10">
            {d.members.map(m => (
              <li key={m.id} className="py-3 flex justify-between text-sm">
                <div><p>{m.user_email || m.user_id}</p><p className="text-[10px] uppercase tracking-widest text-white/40">{m.user_name}</p></div>
                <span className="text-[10px] uppercase tracking-widest text-[#DCB457]">{m.role}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="card-luxe p-6" data-testid="section-plan">
          <p className="eyebrow">Forfait & paiement</p>
          <p className="mt-4 text-sm text-white/75">{d.plan?.name || "Aucun forfait actif"}</p>
          <p className="text-xs text-white/50 mt-1">Souscription : {d.subscription?.status || "aucune"}</p>
          <p className="text-xs text-white/50">Paiements : {d.payments.length}</p>
          {!hasActivePlan && (
            <button onClick={() => setShowSubscribe(true)} data-testid="btn-attribuer-forfait"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 border border-[#DCB457]/40 text-[#DCB457] hover:bg-[#DCB457]/10 text-xs uppercase tracking-widest">
              <CreditCard size={13} /> Attribuer un forfait
            </button>
          )}
        </div>
        <div className="card-luxe p-6 lg:col-span-2" data-testid="section-activity">
          <p className="eyebrow">Activité récente</p>
          <ul className="mt-4 divide-y divide-[#DCB457]/10 text-xs">
            {d.activity.length === 0 ? <li className="py-3 text-white/40 italic">Aucune activité.</li>
              : d.activity.slice(0, 15).map(a => (
                <li key={a.id} className="py-2 flex justify-between">
                  <span className="text-white/70">{a.action}</span>
                  <span className="text-white/40">{a.timestamp ? new Date(a.timestamp).toLocaleString("fr-FR") : ""}</span>
                </li>
              ))}
          </ul>
        </div>
        <div className="card-luxe p-6 lg:col-span-2 text-white/40 text-xs italic" data-testid="section-modules-placeholder">
          Modules MyPlanning · MyGuests · MyPro · MyMemories · MyWallet · MyMusic · MyAssistant · MyLive — bientôt disponibles.
        </div>
      </div>
      <SubscribePlanModal eventId={eventId} open={showSubscribe} onClose={() => setShowSubscribe(false)} />
    </div>
  );
}
